module.exports = __webpack_public_path__ + "assets/img/883b92e4546f8cdddabab4cdc1438083.png";